import { HttpContextToken } from '@angular/common/http';

/** When true, the common interceptor will not rewrite the request URL to the local API. */
export const SKIP_API_URL_REWRITE = new HttpContextToken<boolean>(() => false);

/** When true, the common interceptor will not attach an Authorization header. */
export const SKIP_AUTH_HEADER = new HttpContextToken<boolean>(() => false);
